export default __webpack_public_path__ + "static/media/ic-arrow-black.5fc15648.svg";